import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function IdIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.42857 1C3.87817 1 1 3.87817 1 7.42857V24.5714C1 28.1218 3.87817 31 7.42857 31H24.5714C28.1218 31 31 28.1218 31 24.5714V7.42857C31 3.87817 28.1218 1 24.5714 1H7.42857ZM10.6429 8.5C10.6429 7.61239 9.92333 6.89286 9.03571 6.89286C8.1481 6.89286 7.42857 7.61239 7.42857 8.5V23.5C7.42857 24.3876 8.1481 25.1071 9.03571 25.1071C9.92333 25.1071 10.6429 24.3876 10.6429 23.5V8.5ZM14.9286 6.89286C14.041 6.89286 13.3214 7.61239 13.3214 8.5V23.5C13.3214 24.3876 14.041 25.1071 14.9286 25.1071H17.0714C22.1012 25.1071 26.1786 21.0298 26.1786 16C26.1786 10.9702 22.1012 6.89286 17.0714 6.89286H14.9286ZM16.5357 21.8929V10.1071H17.0714C20.326 10.1071 22.9643 12.7455 22.9643 16C22.9643 19.2545 20.326 21.8929 17.0714 21.8929H16.5357Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
